import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { defaultClothesConditionsOptions, getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { BuilderSections } from '../../util/builder';
import { User } from '../../types/sharetribe/user';
import { MediaPayload } from '../configHelper';

const melinSizes = ['C', 'S', 'XL', 'O/S'];

const getMediaForProduct = (media?: MediaPayload[]) => {
  if (!media) return [];

  const isFirstImage = (mediaItem: MediaPayload) => mediaItem?.url?.includes('_001.');

  const matches = media.filter(isFirstImage);
  const nonMatches = media.filter((mediaItem) => !isFirstImage(mediaItem));

  return [...matches, ...nonMatches];
};

const handleMelinCustomCreditDescription = (data: { recipient: User }) => {
  const { email } = data.recipient?.attributes || {};

  return `Email: ${email}`;
};

// Remove "GOOD" as a condition
const melinConditionOptions = defaultClothesConditionsOptions.slice(0, 3);

export const melinShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({ options: melinConditionOptions }),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: melinSizes }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '1afed9cd939e4d87a91f079c8c501e33',
      [BuilderSections.ListingCardDetails]: '83a9cb52d5374f378fd272bd28c44178',
      [BuilderSections.ListingPageTitleAndVariantDetailsContent]:
        'c24314761de44f609cb7b3d8ce3a1f77',
      [BuilderSections.AboutPageHeroContent]: 'b0a76b36149544ceab551c3570728afc',
    },
  },
  additionalPayoutSettings: {
    buildCustomCreditDescription: handleMelinCustomCreditDescription,
  },
  getMediaForProduct,
  shouldDisableRemovingFeaturedStockPhoto: true,
};
